/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close_square': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M6 4h20a2.002 2.002 0 012 2v20a2.002 2.002 0 01-2 2H6a2.002 2.002 0 01-2-2V6a2.002 2.002 0 012-2zm14.924 15.617a1 1 0 00-.217-.324L17.414 16l3.293-3.293a1 1 0 00-1.414-1.414L16 14.586l-3.293-3.293a1 1 0 00-1.414 1.414L14.586 16l-3.293 3.293a1 1 0 001.414 1.414L16 17.414l3.293 3.293a1 1 0 001.631-1.09z" _fill="#0B2C62"/>'
  }
})
